import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { get, post, del } from "../../api/api"

export default function Projects() {
  const [projects, setProjects] = useState([])
  const [domain, setDomain] = useState("")
  const [name, setName] = useState("")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  async function load() {
    const res = await get("/projects")
    setProjects(res.data)
  }

  async function addProject(e) {
    e.preventDefault()
    setError("")
    setLoading(true)

    try {
      await post("/projects", { name, domain })
      setDomain("")
      setName("")
      await load()
    } catch (err) {
      setError(err.response?.data?.error || "Could not add project")
    } finally {
      setLoading(false)
    }
  }

  async function analyze(projectId) {
    setLoading(true)
    setError("")

    try {
      await post(`/projects/${projectId}/analyze`, {})
      await load()
    } catch (err) {
      setError(err.response?.data?.error || "Audit failed")
    } finally {
      setLoading(false)
    }
  }

  async function remove(projectId) {
    if (!window.confirm("Delete this project?")) return
    await del(`/projects/${projectId}`)
    await load()
  }

  useEffect(() => {
    load().catch((err) => setError(err.response?.data?.error || "Failed to load projects"))
  }, [])

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Projects</h1>
          <p className="muted">Add client domains and run full audits.</p>
        </div>
      </div>

      <form className="card form-row" onSubmit={addProject}>
        <label>
          Project name
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Client site" />
        </label>
        <label>
          Domain
          <input
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
            placeholder="example.com"
            required
          />
        </label>
        <button disabled={loading}>{loading ? "Working..." : "Add project"}</button>
      </form>

      {error && <p className="error">{error}</p>}

      <div className="card table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Domain</th>
              <th>Status</th>
              <th>Last run</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {projects.map((project) => (
              <tr key={project._id}>
                <td>{project.name}</td>
                <td>{project.domain}</td>
                <td>
                  <span className={`status ${project.analysisStatus}`}>
                    {project.analysisStatus}
                  </span>
                </td>
                <td>{project.lastRunAt ? new Date(project.lastRunAt).toLocaleString() : "Never"}</td>
                <td className="actions">
                  <Link className="button" to={`/projects/${project._id}`}>
                    Open
                  </Link>
                  <button onClick={() => analyze(project._id)} disabled={loading}>
                    Analyze
                  </button>
                  <button className="danger" onClick={() => remove(project._id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {projects.length === 0 && (
              <tr>
                <td colSpan="5" className="muted">
                  No projects yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
